import React from "react";
import { Button } from "antd";
import { Link } from "react-router-dom";

const Samplenav = () => {
  return (
    <div className="w-full h-5.4 m-0 rounded-sm bg-inputFieldGrey justify-between flex items-center">
      <Button
        type="link"
        className="m-2 rounded-md text-black hover:!bg-white"
        activeStyle={{ color: "black", backgroundColor: "white" }}
      >
        Services
      </Button>
      <Button
        className="m-2 rounded-lg hover:!bg-white"
        activeStyle={{ color: "black", backgroundColor: "white" }}
      >
        Personal Settings
      </Button>
      <Button
        className="rounded-sm hover:!bg-white hover:!text-black"
        activeStyle={{ color: "black", backgroundColor: "white" }}
      >
        Privacy
      </Button>
      <Button
        type="link"
        className="rounded-sm"
        style={{ color: "black", backgroundColor: "transparent" }}
        activeStyle={{ color: "black", backgroundColor: "white" }}
        hoverable
      >
        Notifications
      </Button>
      <Button
        type="link"
        className="rounded-sm"
        style={{ color: "black", backgroundColor: "transparent" }}
        activeStyle={{ color: "black", backgroundColor: "white" }}
        hoverable
      >
        Delete
      </Button>
      <Button
        type="link"
        className="rounded-sm"
        style={{ color: "black", backgroundColor: "transparent" }}
        activeStyle={{ color: "black", backgroundColor: "white" }}
      >
        <Link to="/main/termsandconditions">Terms And Conditions</Link>
      </Button>
      <Button
        type="link"
        className="rounded-sm"
        style={{ color: "black", backgroundColor: "transparent" }}
        activeStyle={{ color: "black", backgroundColor: "white" }}
        hoverable
      >
        <Link to="/main/privacypolicy">Privacy Policy</Link>
      </Button>
    </div>
  );
};

export default Samplenav;
